import { useCallback } from "react";
import { apiNiches } from "@/common/services";
import { usePaginatedNichePreviews } from "@/common/hooks/usePaginatedNichePreviews";

const NICHES_PAGE_SIZE = 30;

interface IProps {
  order: string;
  query?: string;
  verified?: boolean;
  tags?: string;
  category?: string;
}

export const useSearchNichesPreviews = ({ order, query, tags, category }: IProps) => {
  const request = useCallback((page?: number) => {
    return apiNiches.searchNichesPreviews({
      order,
      count: NICHES_PAGE_SIZE,
      query,
      tags,
      category: category === "All" ? undefined : category,
      page: page || 1,
    });
  }, [order, query, tags, category]);

  const feed = usePaginatedNichePreviews(["nichePreviews", order, query, tags, category], request);

  return { feed };
};
